import Vue from "vue";
import Router from "vue-router";
import store from "@/store"
import {toggleBusy} from "@/util/ComponentUtils";

Vue.use(Router);

const index = new Router({
    // mode: "history",
    base: process.env.BASE_URL,

    routes: [
        {
            path: "",
            name: "Auth",
            redirect: "/auth/login",
            component: () => import("@/layouts/full-layout/FullLayout"),
            meta: {
                requiresAuth: false,
            },
            children: [
                {
                    name: "ContractTable",
                    path: "/all-contracts",
                    component: () =>
                        import("@/views/ContractTable.vue"),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    name: "ContractRegistration",
                    path: "/contract-registration",
                    component: () =>
                        import("@/views/ContractRegistration.vue"),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    name: "SymvolaiografosProfile",
                    path: "/profile",
                    component: () =>
                        import("@/views/SymvolaiografosProfile.vue"),
                    meta: {
                        requiresAuth: true,
                    },
                },
            ],
        },
        {
            path: "/auth/login",
            component: () => import("@/views/authentication/FullLogin"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/auth/login",
            component: () => import("@/layouts/blank-layout/Blanklayout"),
            children: [
                {
                    name: "Login",
                    path: "login",
                    component: () => import("@/views/authentication/FullLogin"),
                    meta: {
                        requiresAuth: false,
                    },
                },
                {
                    name: "Error",
                    path: "error",
                    component: () => import("@/views/authentication/Error"),
                },
            ],
        },
        {
            path: "/auth/logout",
            name: "logout",
            component: () => import("@/views/authentication/FullLogin"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "*",
            component: () => import("@/views/authentication/Error"),
        },
    ],
});

index.beforeResolve(async (to, from, next) => {
    try {
        if (to.name !== 'Auth') {
            await toggleBusy(true)
        }
        if (to.name) {
            // Start the route progress bar.
            // NProgress.start(800);

            if (to.matched.some(route => route.meta.requiresAuth)) {
                if (store.getters['auth/isAuthenticated']) {
                    next();
                } else {
                    next({path: '/'});
                }
            }

        }
        next();
    } catch (e) {
        next({path: '/'});
        console.log(e)
    }
    return false
})

index.afterEach(() => {
    // Complete the animation of the route progress bar.
    // toggleBusy(false)
});

export default index;
